import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DIAGRAM_VERSION_STATES_ENUM} from '../models/diagram-version.constant';

@Pipe({
  name: 'getVersionLabel',
  standalone: true
})
export class GetVersionLabelPipe implements PipeTransform {
  constructor(private translateSvc: TranslateService) {}

  transform(version: any): string {
    if (version.state === DIAGRAM_VERSION_STATES_ENUM.DRAFT) {
      return this.translateSvc.instant('TOOLBAR.AUTHORISATION_TASK_STATUS_IN_PROGRESS');
    }

    return `${this.translateSvc.instant('ASIDE_R.VERSION')} ${version.version || ''}`;
  }
}
